import { Component, OnInit, Input } from '@angular/core';
import { AppData } from "../../models/data.model";
import { Router } from "@angular/router";
import { QaService } from "../../services/qa.service";
import { StartupService } from "../../services/startup.service";
import { MetaService } from '../../services/meta.service';
import { HistoryService } from "../../services/history.service";
import { trigger, state, style, animate, transition, query, stagger, group } from '@angular/animations';

@Component({
  selector: 'app-postal',
  templateUrl: './postal.component.html',
  styleUrls: ['./postal.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition('void => *', [
        query('.animate-item', style({ transform: 'translateX(600px)', opacity: 0 })),
        query('.animate-item', stagger('50ms', group([
          animate('200ms cubic-bezier(0.55, 0.055, 0.675, 0.19)', style({ opacity: 1 })),
          animate('300ms cubic-bezier(.02, .01, .47, 1)', style({ transform: 'translateX(0)' }))
        ])))
      ]),
      transition('* => exit', [
        state('exit', style({ transform: 'translateX(-600px)', opacity: 0 })),
        query('.animate-item', style({ transform: 'translateX(0)', opacity: 1 })),
        query('.animate-item', stagger('50ms', group([
          animate('200ms cubic-bezier(0.55, 0.055, 0.675, 0.19)', style({ opacity: 0 })),
          animate('300ms cubic-bezier(.02, .01, .47, 1)', style({ transform: 'translateX(-600px)' }))
        ])))
      ])
    ])
  ]
})
export class PostalComponent implements OnInit {
  data: AppData;
  body: Element = document.getElementsByTagName('body')[0];
  animationState: string = 'in';

  constructor(public startupService: StartupService,
    private historyService : HistoryService,
    private router: Router,
    public qaService: QaService,
    public metaTagService: MetaService) {
    this.qaService.updateProgress(this.startupService.startupData.PostalCodeScreen.Progress);
  }

  ngOnInit() {

    this.body.className += 'overflow-hide';
    setTimeout(() => this.body.classList.remove('overflow-hide'), 2000);

    this.metaTagService.setMetaTags(
      // this.startupService.startupData.PostalCodeScreen.DocumentPageTitle,
      '',
      this.startupService.startupData.PostalCodeScreen.DocumentPageTitle,
      this.startupService.startupData.PostalCodeScreen.DocumentPageKeyWords
    );
  }

  skipQuestion() {
    this.animationState = 'exit';
    var context = this;
    setTimeout(() => {
      var urlArray = context.startupService.getStepRouterLink();
      context.historyService.next(`/${urlArray[1]}/${urlArray[2]}/0`, context.qaService.answers);
      context.router.navigate(context.startupService.getStepRouterLink());
    }, 300);
  }

  next($event: Event, value: string) {
    $event.preventDefault();
    let pattern = new RegExp(this.startupService.startupData.PostalCodeScreen.PostalCodePattern);

    if(pattern.test(value))
    {
      var context = this;
      context.animationState = 'exit';
      setTimeout(() => {
        var urlArray = context.startupService.getStepRouterLink();
        context.historyService.next(`/${urlArray[1]}/${urlArray[2]}/168`, context.qaService.answers);
        context.router.navigate(context.startupService.getStepRouterLink());
      }, 300);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/postal/postal.component.ts